import React, { FC } from "react";
import { Box, Label, Input } from "theme-ui";
import { InputFieldType } from "./input-types";

export const InputField: FC<InputFieldType> = ({
  label,
  type,
  required,
  hover,
  placeholder,
  value,
  onChange,
  ...props
}: InputFieldType) => (
  <Box
    {...props}
    sx={{
      "@media screen and (max-width: 767px)": {
        gridColumn: "1 / span 2",
      },
    }}
  >
    <Label>{label}</Label>
    <Input
      placeholder={placeholder}
      required={required}
      title={hover}
      type={type}
      maxLength={256}
      value={value}
      onChange={(event: React.ChangeEvent<HTMLInputElement>): void =>
        onChange?.(event.target.value)
      }
    />
  </Box>
);
